import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { User } from '../models/user';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    private http: HttpClient,
    private cookie: CookieService,
    private router: Router
  ) { }
  public apiUrl: string = environment.apiUrl
  secretKey: string = "taekwonv"

  //헤더값 세팅
  getHeaders() {
    let accessToken = this.cookie.get("accessToken")
    let headers = new HttpHeaders({
      "Authorization" : "Bearer " + accessToken,
    })
    return headers;
  }
  getUserInfo() {
    let userInfoEnc = this.cookie.get("userInfo")
    let user: User 
    if(userInfoEnc) {
      user = JSON.parse(this.decryption(userInfoEnc))
    }
    return user
  } 
  encryption(value: string) {
    var secretKey = sha256(this.secretKey)
    var key = CryptoJS.enc.Utf8.parse(secretKey);
    var iv = CryptoJS.enc.Utf8.parse(secretKey);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }
  decryption(value: string) {
    var secretKey = sha256(this.secretKey)
    var key = CryptoJS.enc.Utf8.parse(secretKey);
    var iv = CryptoJS.enc.Utf8.parse(secretKey);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } 

  getIsMobile(): boolean {
    let isMobile: boolean = false
    if(window.innerWidth < 1024) {
      isMobile = true
    }
    return isMobile;
  }
}
